import script from "./FooterCustomerRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterCustomerRegister.vue?vue&type=script&setup=true&lang=js"

import "./FooterCustomerRegister.vue?vue&type=style&index=0&id=2effa138&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2effa138"]])

export default __exports__